import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";

import widgets from "styles/widgets";
import { UserDto } from "dtos/user.dto";
import displayStyles from "styles/display-styles";
import { ActionDto } from "dtos/shard/action.dto";

import ActionView from "../views/action-view";
import ActionEditor from "../editors/action-editor";
import { statsPanel, toggleStatsPanel } from "utils";

const styles = createUseStyles({});

export default function ActionDisplay(props: {
    user?: UserDto, // Optional dto of the user.
    className?: string, // Optional css class name to use.
    action?: Partial<ActionDto>, // The action dto to display, if undefined a blank action will be displayed instead.
    onSave?: (action: ActionDto) => void, // A function to call when created or updated.
    onClose?: () => void, // A function to call when the close button is clicked, if not set the close button is hidden.
}): JSX.Element
{
    // States:
    const [stats, setStats] = useState(statsPanel());
    const [actionPreview, setActionPreview] = useState(props.action);

    // Effects:
    useEffect(() => {
        setActionPreview(props.action);
    }, [props.action]);

    // Styles:
    const widgetClasses = widgets();
    const displayClasses = displayStyles();
    const classes = styles();

    // Components:
    let statsComp: JSX.Element | undefined;
    if (stats) {
        // Action Stats (Editor for Admins):
        if (props.user?.super) {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${displayClasses.editor}`}>
                        <h3>Editor:</h3>
                        <ActionEditor
                            user={props.user}
                            action={props.action}
                            preview={actionPreview}
                            onPreviewUpdate={setActionPreview}
                            onSave={props.onSave}
                            onClose={props.onClose}
                        />
                    </div>
                </div>
            );
        } else {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${widgetClasses.column}`}>
                        <h3>Stats:</h3>
                        <ul>
                            <li>Name: {props.action?.name}</li>
                            <li>Element: {props.action?.element?.name}</li>
                            <li>Type: {props.action?.actionType?.name}</li>
                            <li>Effect: {props.action?.actionEffect?.name}</li>
                            <li>Power: {props.action?.power}</li>
                        </ul>
                    </div>
                </div>
            );
        }
    }

    // Return Component:
    return (
        <div className={`${displayClasses.container} ${props.className ?? ""}`}>
            <div className={`${displayClasses.controls}`}>
                <div className={`${displayClasses.button} ${statsPanel() ? displayClasses.buttonActive : ""}`} onClick={() => setStats(toggleStatsPanel())}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconStats}`}></div>
                </div>
                {props.onClose && <div className={`${displayClasses.button}`} onClick={() => props.onClose!()}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconClose}`}></div>
                </div>}
            </div>
            <ActionView action={actionPreview} />
            {statsComp}
        </div>
    );
}
